import {
  createDocument,
  getAllData,
  updateDocumentByID,
} from "apis/customApiHandler";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Input, Select } from "styled";
import { TD, TH } from "styled/table";
import { BiCloudDownload } from "react-icons/bi";
import axios from "apis/axios";
import ReactSelect from "react-select";
import Spinner from "components/Spinner";
import exportExcel from "utils/exportExcel";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import getFormattedDate from "utils/helpers";
import Modal from "components/Modal";
import { useFormik, Form, FormikProvider } from "formik";
import InputField from "components/formik/InputField";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";

import { FaEdit, FaEye, FaTrash } from "react-icons/fa";

const  TyreValidationReport = () => {
  const ids = window.location.search.split("=")[1];
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [page, setPage] = useState(1);
  const [kmFrom, setKmFrom] = useState("");
  const [kmTo, setKmTo] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [contractType, setContractType] = useState("All");
  const [alignment, setAlignment] = useState("All");
  const [rotation, setRotation] = useState("All");
  const [replacement, setReplacement] = useState("All");
  const [reportData, setReportData] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [soldOut, setSoldOutValidation] = useState("");
  const [reValidation, setReValidation] = useState("All");

  const getData = async (pg) => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      setData([]);
      return;
    }
    setIsLoading(true);
    try {
      const dt = await createDocument("/tyre-validation/report", {
        ...(selectedFleets?.includes("all")
          ? {
              fleets: allFleets?.data?.map(fleet => fleet._id).join(",") || "", // Send all fleet IDs
            }
          : selectedFleets.length && {
              fleets: selectedFleets.filter(fleet => fleet !== "all" && fleet !== "clear").join(","), // Send fleet IDs
            }),
        ...(selectedHubs?.includes("all")
          ? {
              hubs: selectedFleets?.includes("all")
                ? allHubs?.data?.map(hub => hub._id).join(",") || "" // Send all hub IDs if all fleets selected
                : allHubs?.data?.filter(hub => {
                    const selectedFleetCodes = allFleets?.data?.filter(fleet =>
                      selectedFleets?.includes(fleet._id)
                    )?.map(fleet => fleet.fleetCode);
                    return selectedFleetCodes?.includes(hub.fleetCode);
                  })?.map(hub => hub._id).join(",") || "", // Send hub IDs filtered by selected fleets
            }
          : selectedHubs.length && {
              hubs: selectedHubs.filter(hub => hub !== "all" && hub !== "clear").join(","), // Send hub IDs
            }),

        ...(selectedUsers?.includes("all")
          ? {
              validatedBy: getUsers()
                .filter(
                  (item) => item.value !== "all" && item.value !== "clear"
                )
                .map((item) => item.value)
                .join(","),
            }
          : selectedUsers.length && {
              validatedBy: selectedUsers.map((user) => user).join(","),
            }),
        ...(ids && {
          ids,
        }),
        ...(searchQuery && { searchQuery }),
        dateFrom,
        dateTo,
        ...(soldOut && { soldOut }),
        ...(reValidation !== "All" && reValidation !== "" && { reValidation }),
        ...(contractType !== "All" && contractType !== "" && { contractType })
      });
      // console.log(dt)
      console.log("dt----------",dt)
      setData(dt);
    } catch (err) {
      setData(null)
    } finally {
      setIsLoading(false);
    }
  };
 
  useEffect(() => {
    if (
      (selectedFleets.length === 0 || selectedHubs.length === 0) &&
      !searchQuery
    ) {
      // console.log("");
    } else getData(page);
  }, [page]);

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: users } = useQuery([`/user`, selectedHubs?.length, dateFrom, dateTo, selectedFleets], () =>
    createDocument("/tyre-validation/distinct-users/", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: allFleets?.data?.map(fleet => fleet._id).join(",") || "", // Send all fleet IDs
          }
        : selectedFleets.length && {
            fleets: selectedFleets.filter(fleet => fleet !== "all" && fleet !== "clear").join(","), // Send fleet IDs
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: selectedFleets?.includes("all")
              ? allHubs?.data?.map(hub => hub._id).join(",") || "" // Send all hub IDs if all fleets selected
              : allHubs?.data?.filter(hub => {
                  const selectedFleetCodes = allFleets?.data?.filter(fleet =>
                    selectedFleets?.includes(fleet._id)
                  )?.map(fleet => fleet.fleetCode);
                  return selectedFleetCodes?.includes(hub.fleetCode);
                })?.map(hub => hub._id).join(",") || "", // Send hub IDs filtered by selected fleets
          }
        : selectedHubs.length && {
            hubs: selectedHubs.filter(hub => hub !== "all" && hub !== "clear").join(","), // Send hub IDs
          }),
      dateFrom,
      dateTo,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getUsers = useCallback(() => {
    if (users && users.data && users.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...users?.data?.map((user) => {
          return {
            value: user._id,
            label: user.name,
          };
        }),
      ];
    }else{
      // setSelectedUsers([])
      return []
    }
  }, [users]);

  useEffect(()=>{
    if(!users?.data?.length) setSelectedUsers([])
  }, [users])

  const setFleetMapData = useCallback(() => {
    let selectedFleetCodes = allFleets?.data?.map((fleet) => fleet.fleetCode);
    let selectedHubsData = [];
    if (selectedHubs?.includes("all"))
      selectedHubsData = allHubs?.data?.filter((hub) =>
        selectedFleetCodes?.includes(hub.fleetCode)
      );
    else
      selectedHubsData = allHubs?.data?.filter((hub) =>
        selectedHubs?.includes(hub._id)
      );
    const mp = {};
    selectedHubsData?.map((hub) => {
      if (selectedFleetCodes?.includes(hub.fleetCode)) {
        if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
        mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
      }
    });

    setFleetMap({...mp});
  }, [allFleets?.data, allHubs?.data, selectedHubs])


  const getDownloadData = async ()=>{
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setDownloading(true)
    try{
      console.log(selectedHubs)
      const myPromise = axios({
        method: "post",
        url: `report/fleetStockDetails/download`,
        data: {
          showValidationCols: true,
          ...(selectedHubs?.includes("all")
            ? {
                hubs: selectedFleets?.includes("all")
                  ? allHubs?.data?.map(hub => hub._id).join(",") || "" // Send all hub IDs if all fleets selected
                  : allHubs?.data?.filter(hub => {
                      const selectedFleetCodes = allFleets?.data?.filter(fleet =>
                        selectedFleets?.includes(fleet._id)
                      )?.map(fleet => fleet.fleetCode);
                      return selectedFleetCodes?.includes(hub.fleetCode);
                    })?.map(hub => hub._id).join(",") || "", // Send hub IDs filtered by selected fleets
              }
            : selectedHubs.length && {
                hubs: selectedHubs.filter(hub => hub !== "all" && hub !== "clear").join(","), // Send hub IDs
              }
            ),
            ...(selectedFleets?.includes("all")
            ? {
                fleets: allFleets?.data?.map(fleet => fleet._id).join(",") || "", // Send all fleet IDs
              }
            : selectedFleets.length && {
                fleets: selectedFleets.filter(fleet => fleet !== "all" && fleet !== "clear").join(","), // Send fleet IDs
              }
            ),
          ...(selectedUsers?.includes("all")
            ? {}
            : selectedUsers.length && {
                validatedBy: selectedUsers.map((user) => user).join(","),
              }),
          dateFrom: dateFrom,
          dateTo: dateTo,
          ...(soldOut && { soldOut }),
          ...(reValidation !== "All" && reValidation !== "" && { reValidation }),
          ...(contractType !== "All" && contractType !== "" && { contractType }),
          reportName: "Tyre Validation Report",
        },
      });
  
      await toast.promise(
        myPromise,
        {
          loading: 'Request Initiated, Please Hold onn',
          success: (dt) => dt.data.message,
          error: (err) =>
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            'Something went wrong',
        },
        {
          success: {
            duration: 3000,
            icon: '📩',
          },
        }
      );
      
    }catch(err){
      
    }
    finally{ setDownloading(false) }  

  }


  // useEffect(()=>{
  //   setFleetMapData();
  // }, [allFleets?.data])

  console.log(data)

  return (
    <div>
      <div className="flex flex-col text-gray-500">
        <div className="w-full px-8 flex justify-center items-center gap-4">
          <label className="w-full py-3">
            Select Fleets
            <ReactSelect  
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find((item) => item?.value === fleet)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if(allValues?.includes("clear")){
                  // console.log(allValues)
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if(!selectedFleets?.includes("all") && allValues.includes("all")){
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  // console.log("first");
                  // console.log(getFleetOptions())
                  value = value.filter(item => item.value!== "all")
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );
                
                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                // console.log({allHubs, selectedHubs})
                
                setSelectedFleets(value.map((fleet) => fleet.value));
                }
            }
              name="fleets"
              isMulti = {true}
            />
          </label>
          <label className="w-full py-3">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  // console.log({hub})
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                // console.log({allValues})
                if(allValues.includes("clear")){
                  setSelectedHubs([])
                  return;
                }
                if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                  setSelectedHubs(["all"])
                } 
                else {
                  // console.log({value})
                  value = value.filter(value => value.value!== "all")
                  // console.log({value})
                  let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                    selectedFleets?.includes(fleet._id)
                  )?.map(fleet=>fleet.fleetCode);
                  // console.log({allValues})
                
                  const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>

          <label className="w-full py-3">
            Select Inspected By
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getUsers()}
              value={
                selectedUsers &&
                selectedUsers?.map((user) => {
                  return {
                    value: user,
                    label: getUsers()?.find((item) => item?.value === user)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                if (allValues.includes("clear")) {
                  setSelectedUsers([]);
                  return;
                }
                if (!selectedUsers.includes("all") && allValues.includes("all")) {
                  setSelectedUsers(["all"]);
                  return;
                }
                if (selectedUsers.includes("all")) {
                  value = value.filter((item) => item.value !== "all");
                }
                setSelectedUsers(value.map((user) => user.value));
              }}
              name="users"
              isMulti={true}
            />
          </label>

          <label className="w-full py-3">
              Sold Out
              <Select
                name="soldOut"
                value={soldOut}
                onChange={(e) => setSoldOutValidation(e.target.value)}
              >
                <option value={""}>All</option>
                <option value={"Yes"}>Yes</option>
                <option value={"No"}>No</option>
              </Select>
            </label>

          <label className="w-full py-3">
              Re-Validation
              <Select
                name="reValidation"
                value={reValidation}
                onChange={(e) => setReValidation(e.target.value)}
              >
                <option value={"All"}>All</option>
                <option value={"Yes"}>Yes</option>
                <option value={"No"}>No</option>
              </Select>
            </label>

          <label className="w-full py-3">
              Contract Type
              <Select
                name="contractType"
                value={contractType}
                onChange={(e) => setContractType(e.target.value)}
              >
                <option value={"All"}>All</option>
                <option value={"CPKM"}>CPKM</option>
                <option value={"NON CPKM"}>Non-CPKM</option>
              </Select>
            </label>
        </div>
        <div className="w-full px-8 flex justify-start items-center gap-4">
          <label>
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              max={getFormattedDate()}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
          <Button
            type="button"
            className='mt-5'
            disabled={(!selectedHubs.length)}
            bgPrimary
            onClick={async () => {
              setFleetMapData();
              getData()}
            }
          >
            Search
          </Button>

          {downloading ? 'Downloading...' : selectedHubs.length !==0 &&  <BiCloudDownload
          className="w-10 mt-5 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
          onClick={() => {
            getDownloadData()
          }}

          
        />}
        </div>
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {data && (
            <div className="flex flex-col m-2 lg:m-10">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                          {data && data.data?.length ? (
                            <tr>
                            <TH scope="col">S.N.</TH>
                            <TH scope="col">Fleet Name</TH>
                            <TH scope="col">Hub Name</TH>
                            {/* {Object.keys(data.data[0]).map((key) => {
                              if(key!== "total" && key!== "fleetCode") return <TH scope="col"> {key.toUpperCase()} </TH>;
                            })}
                            <TH scope = "col"> Total </TH> */}
                            
                            {data.cols.map(item => {
                              return <TH scope="col">{item}</TH>
                            })}
                            </tr>
                          ) : (
                            <tr><TH scope="col"> No Data available </TH></tr>
                          )}
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {data &&
                          data.data?.map((d, idx) => {
                            console.log('viewdata--',d.hub[0].hubName);
                            
                           return <ViewList
                              soldOut={soldOut}
                              reValidation={reValidation}
                              contractType={contractType}
                              page={page}
                              data={d}
                              hubName={d.hub[0].hubName}
                              idx={idx}
                              getData={getData}
                              fleetMap={fleetMap}
                              dateFrom = {dateFrom}
                              dateTo = {dateTo}
                              selectedUsers = {selectedUsers}
                              selectedFleets={selectedFleets}
                              allFleets={allFleets}
                              allHubs={allHubs}
                              selectedHubs={selectedHubs}  
                              cols={data.cols}
                              casingTypeMap={data.casingTypeMap}
                             
                            />
})}
                      </tbody>
                        {data?.totalRow && data.data?.length ? <tfoot>
                          <tr className="text-gray-600 font-semibold bg-green-100">
                            <TD></TD>
                            <TD >
                              TOTAL
                            </TD>
                            <TD></TD>
                            {data.cols.map(col =><TD className= "text-center">{data.totalRow[col+"Count"]}</TD>)}
                          </tr>
                        </tfoot> : <></>}
                      
                    </table>
                  </div>
                </div>
              </div>

              {data && data.pageInfo && data.pageInfo.total && (
                <div className="container mx-auto flex justify-center items-center gap-2 py-5">
                  <Button
                    onClick={() => {
                      setPage((p) => Math.max(p - 1, 1));
                    }}
                    disabled={page === 1}
                    className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                    primary
                  >
                    <div className="flex gap-1 items-center">
                      <IoMdArrowBack />
                      Prev Page
                    </div>
                  </Button>
                  <span className="text-gray-600 px-4">{`showing: ${
                    (page - 1) * 300 + 1
                  } - ${Math.min(data?.pageInfo?.total, page * 300)} of ${
                    data.pageInfo.total
                  }`}</span>

                  {data.pageInfo.total > page * 300 && (
                    <Button
                      onClick={() => {
                        setPage((p) => Math.min(p + 1, data?.pageInfo?.total));
                      }}
                      disabled={page === data?.pageInfo?.total}
                      className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                      primary
                    >
                      <div className="flex gap-1 items-center">
                        Next Page
                        <IoMdArrowForward />
                      </div>
                    </Button>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default TyreValidationReport;

const ViewList = ({ data,hubName,  page, idx, getData, fleetMap,dateFrom, dateTo,  selectedUsers, soldOut, reValidation, contractType, allFleets,allHubs,selectedFleets,selectedHubs, cols, casingTypeMap}) => {
  console.log('cols--',cols);
  console.log("index---",idx)
  const [fleet, setFleet] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [showEditModel, setShowEditModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isLoading, setIsLoading] = useState(true)
  const [modalQueryProp, setModalQueryProp] = useState(null);

  console.log('fleetMap--',fleetMap);

  // const modalHandler = useCallback(
  //   (data) => {
  //     // console.log({data})
  //     if (data) {
  //       setModalData(data);
  //       setShowModal(true);
  //     } else {
  //       setShowModal(false);
  //       setModalData([]);
  //     }
  //   },
  //   [showModal, modalData]
  // );

  console.log('selectedFleets--',selectedFleets,selectedHubs);

  const getModalData = async (modalQueryProp,fleetId,hubId) => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setShowModal(true)
    if (modalQueryProp) {
      setIsLoading(true);
      console.log({casingTypeMap}, {modalQueryProp})
      // console.log("making modal call")
      const dt = await createDocument("/tyre-validation/report/modalInfo", {
            fleets: modalQueryProp?.fleetId,
            hubs: modalQueryProp?.hubId,
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
        status:modalQueryProp?.status.toUpperCase(),
        ...(soldOut && { soldOut }),
        ...(reValidation !== "All" && reValidation !== "" && { reValidation }),
        ...(contractType !== "All" && contractType !== "" && { contractType }),
        ...(selectedUsers?.includes("all")
                        ? {}
                        : selectedUsers.length && {
                          validatedBy: selectedUsers.map((user) => user).join(","),
                        }),
        .../CASING/i.test(modalQueryProp.status) &&  {
          casingType: casingTypeMap[modalQueryProp.status] ?? "---"
        }
      });
      // console.log(dt)
      setModalData(dt)
      setModalQueryProp(modalQueryProp);
    }
    setIsLoading(false);
  }

  console.log('viewData--',data);

  const fetchFile = async (url) => {
    const originalImage = url;
    const image = await fetch(originalImage);

    //Split image name
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();

    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadDiv = (data, fleetName,fleetId,hubId,fleetCode, casingTypeId = null, status, dateFrom, dateTo, selectedUsers, soldOut, reValidation, contractType)=>{
    console.log('fleetName',fleetName,fleetId,hubId);
    return data?.length!==0  ? <div className="flex gap-2 items-center justify-center">

    <span
      className="hover:text-green-500 cursor-pointer"
      onClick={() => {getModalData({data: data,fleetId,hubId, status, casingTypeId, dateFrom, dateTo, fleetCode, reValidation, contractType, title: "Tyre Validation Information " + fleetName, }); setFleet(fleetName)}}
    >
      {data ?? 0}
    </span>
   
  </div>: <div className="flex gap-2 items-center justify-center">0</div>
  }

  const [photo, setPhoto] = useState(null)
  console.log('modalData--',modalQueryProp);
  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={modalQueryProp?.title}
          className="max-w-2xl"
        >
          {/* {console.log(modalData, fleetMap)} */}
          {/* <h1>This is the modal</h1> */}
          {isLoading ? <Spinner /> : <>
            <h1 className="w-full flex justify-end text-end px-2 my-1">
              <Button
                onClick={() => {
                  const myPromise = axios({
                    method: 'post',
                    data: {
                      showValidationCols: true,
                      ...(fleetMap[modalQueryProp.fleetCode]?.length && {
                        hubs: modalQueryProp?.hubId,
                      }),
                      ...(["reuse", "repair", "scrap", "fitted", "missing", "READY_TO_FIT_OUT"].includes(modalQueryProp?.status) ? {
                        status: modalQueryProp?.status.toUpperCase()
                      } : modalQueryProp?.casingTypeId !== null && {
                        casingType: modalQueryProp?.casingTypeId
                      }),
                      ...(selectedUsers?.includes("all")
                        ? {}
                        : selectedUsers.length && {
                          validatedBy: selectedUsers.map((user) => user).join(","),
                        }),
                      dateFrom: modalQueryProp.dateFrom,
                      dateTo: modalQueryProp.dateTo,
                      reportName: "Tyre Validation Report",
                      ...(soldOut && { soldOut }),
                      ...(modalQueryProp.reValidation !== "All" && modalQueryProp.reValidation !== "" && { reValidation: modalQueryProp.reValidation }),
                      ...(modalQueryProp.contractType !== "All" && modalQueryProp.contractType !== "" && { contractType: modalQueryProp.contractType }),
                    },
                    url: `report/fleetStockDetails/download`,
                  });

                  toast.promise(myPromise, {
                    loading: 'Request Initiated, Please Hold on',
                    success: (dt) => dt.data.message,
                    error: (err) => err?.response?.data.error ||
                      err?.response?.data.message ||
                      err?.message ||
                      'Something went wrong',
                  }, {
                    success: {
                      duration: 3000,
                      icon: '📩',
                    },
                  });
                }}
                className="text-blue-500 hover:scale-105 cursor-pointer text-right"
              >
                Download
              </Button>
            </h1>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <TH scope="col">S.N.</TH>
                  <TH scope="col">Fleet Name</TH>
                  <TH scope="col">Stencil Number</TH>
                  <TH scope="col">Prev Tyre Location</TH>
                  <TH scope="col">Tyre Location</TH>
                  <TH scope="col">Casing Type</TH>
                  <TH scope="col">Prev Scrap Reason</TH>
                  <TH scope="col">Scrap Reason</TH>
                  <TH scope="col">Sold Out</TH>
                  <TH scope="col">G1</TH>
                  <TH scope="col">G2</TH>
                  <TH scope="col">G3</TH>
                  <TH scope="col">G4</TH>
                  <TH scope="col">averageNSD</TH>
                  <TH scope="col">Comment</TH>
                  <TH scope="col">Validated By</TH>
                  <TH scope="col">validation Date</TH>
                  <TH scope="col">Photo1</TH>
                  <TH scope="col">Photo2</TH>
                  <TH scope="col">Photo3</TH>
                  <TH scope="col">Photo4</TH>


                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {modalData && modalData?.data?.map((tyre, index) => {
                  console.log('modalDataTyre--', tyre);

                  return <tr>
                    <TD>{index + 1}</TD>
                    <TD>{`${fleet} (${data?.fleetCity || "-"})`}</TD>
                    <TD className={tyre.soldOut && "text-rose-700"}>{tyre.stencilNo}</TD>
                    <TD>{tyre.prevTyreLocation === "FITTED" ? "On Wheel" : tyre.prevTyreLocation}</TD>
                    <TD>{tyre.tyreLocation === "FITTED" ? "On Wheel" : tyre.tyreLocation}</TD>
                    <TD>{modalData.casingTypeMap?.[tyre.casingType?.toString()] ?? tyre.tyreLocation}</TD>
                    <TD>{(tyre.prevScrapReason ?? tyre.scrapReason) ?? "N/A"}</TD>
                    <TD>{tyre.scrapReason ?? "N/A"}</TD>
                    <TD>{tyre.soldOut ? "YES" : "NO"}</TD>
                    <TD>{tyre.G1}</TD>
                    <TD>{tyre.G2}</TD>
                    <TD>{tyre.G3}</TD>
                    <TD>{tyre.G4}</TD>
                    <TD>{tyre.averageNSD}</TD>
                    <TD>{tyre.comment}</TD>
                    <TD>{tyre.validatedBy}</TD>
                    <TD>{getFormattedDate(tyre.tyreValidationDate, "-")}</TD>
                    <TD onClick={() => { setPhoto(tyre.photo1) }} className={`underline cursor-pointer ${tyre.photo1 ? "text-green-500" : "text-black"}`}>{tyre.photo1 ? "Yes" : "No"}</TD>
                    <TD onClick={() => { setPhoto(tyre.photo2) }} className={`underline cursor-pointer ${tyre.photo1 ? "text-green-500" : "text-black"}`}>{tyre.photo2 ? "Yes" : "No"}</TD>
                    <TD onClick={() => { setPhoto(tyre.photo3) }} className={`underline cursor-pointer ${tyre.photo1 ? "text-green-500" : "text-black"}`}>{tyre.photo3 ? "Yes" : "No"}</TD>
                    <TD onClick={() => { setPhoto(tyre.photo4) }} className={`underline cursor-pointer ${tyre.photo1 ? "text-green-500" : "text-black"}`}>{tyre.photo4 ? "Yes" : "No"}</TD>

                  </tr>
                })}
              </tbody>
            </table>
          </>}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{(parseInt(page) - 1) * 300 + (idx + 1)}</TD>
        <TD>{`${data.fleet} (${data.fleetCity || "-"})`}</TD>
        <TD>{hubName}</TD>

        
        {cols.map(col => {
          let casingTypeId = null;

          if (/CASING/i.test(col) && casingTypeMap[col]) {
            casingTypeId = casingTypeMap[col];
          }
          
          return (
            <TD>
              {downloadDiv(
                data[col],
                data.fleet,
                data.fleetId,
                data.hubId,
                data.fleetCode,
                casingTypeId,
                col,
                dateFrom,
                dateTo,
                selectedUsers,
                soldOut,
                reValidation,
                contractType
              )}
            </TD>
          );
        })}
      </tr>

      {photo && <Modal handleClick={() => setPhoto(null)}
        title={"Photo"}
        className="w-64 h-64"
      >
        <div className="w-[50%] h-[50%] justify-center mx-auto items-center">
          <img src={photo} className="w-full" />
        </div>
      </Modal>
      }
    </Fragment>
  );
};
